import { getLabel } from "../labels";

export function getTicketStatusDescription(status, cashout) {
    let ticketStatus = null;
    switch(status) {
        case 'opened':
            ticketStatus = getLabel('ticket.opened');
            break;
        case 'winning':
            ticketStatus = getLabel('ticket.winning');
            break;
        case 'winning_cashback':
            ticketStatus = getLabel('ticket.winning_cashback');
            break;
        case 'losing':
            ticketStatus = getLabel('ticket.losing');
            break;
        case 'voided':
            ticketStatus = getLabel('ticket.voided');
            break;
        case 'expired':
            ticketStatus = getLabel('ticket.expired');
        break;
        case 'paid':
            ticketStatus = cashout ? (getLabel('ticket.paid') + ' - ' + getLabel('cashout.button_text')) : getLabel('ticket.paid');
            break;
        default:
            break;
    }
	return ticketStatus;
}
